const actions = {
  // USER CONFIRM popups -------------------------------------------
  async confirmDeleteAccount({dispatch}, callback) {
    dispatch('popups/show/confirm', {
      message: 'Are you sure you want to delete your Account?',
      buttons: [
        {
          name: 'Cancel',
          id: 'cancel',
          function: 'close'
        },
        {
          name: 'Delete my account',
          id: 'delete',
          function: callback
        },
      ]
    }, {root: true})
  },
  async confirmDeleteAvatar({dispatch}, callback) {
    dispatch('popups/show/confirm', {
      message: 'Are you sure you want to delete your Avatar?',
      buttons: [
        {
          name: 'Cancel',
          id: 'cancel',
          function: 'close'
        },
        {
          name: 'Delete my avatar',
          id: 'delete',
          function: callback,
          colour: 'red'
        },
      ]
    }, {root: true})
  },
};

export default {
  namespaced: true,
  actions
};
